import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Hidden = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  var numericSize = size === 'medium' ? 16 : size === 'small' ? 14 : 12;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: numericSize,
    ref: ref,
    role: "img",
    width: numericSize,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Hidden') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fill: color,
    d: "M14.679 6.999l1.445-1.445C17.265 6.75 18 8.024 18 9c0 2.51-4.858 7-9 7-.915 0-1.858-.203-2.773-.55l1.579-1.578A5.74 5.74 0 009 14c3.866 0 7-4.367 7-5 0-.25-.49-1.084-1.321-2.001zM10.416 4.19A5.504 5.504 0 009 4C5.134 4 2 8.102 2 9c0 .366.522 1.267 1.403 2.204L1.967 12.64C.77 11.423 0 10.082 0 9c0-2.697 4.791-7 9-7 .969 0 1.977.246 2.952.654L10.416 4.19zm3.605-1.483a1 1 0 111.414 1.414L4.121 15.435a1 1 0 01-1.414-1.414L14.021 2.707z",
    fillRule: "evenodd"
  }));
});
Hidden.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(['xsmall', 'small', 'medium']),
  title: _pt.string,
  titleId: _pt.string
} : {};
export default Hidden;